var _toConsumableArray = require("/Users/danbook/Sites/realtaglines-fe/node_modules/@babel/runtime/helpers/toConsumableArray");

var partial = function partial(fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, newArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      newArgs[_key2] = arguments[_key2];
    }

    if (args.length + newArgs.length >= fn.length) {
      return fn.apply(void 0, _toConsumableArray(args.concat(newArgs)));
    } else {
      return partial.apply(void 0, [fn].concat(_toConsumableArray(args.concat(newArgs))));
    }
  };
};

partial.rapply = function (fn) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return function () {
    for (var _len4 = arguments.length, newArgs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      newArgs[_key4] = arguments[_key4];
    }

    if (args.length + newArgs.length >= fn.length) {
      return fn.apply(void 0, _toConsumableArray(newArgs.concat(args)));
    } else {
      return partial.rapply.apply(partial, [fn].concat(_toConsumableArray(newArgs.concat(args))));
    }
  };
};

var exports = module.exports = partial;